import { Center, Loader, MantineSpacing, Text } from '@mantine/core';

interface Props {
  mt?: MantineSpacing;
  label?: string;
}

export const CenteredLoading = ({ mt, label }: Props) => (
  <Center mt={mt}>
    <Loader color={'var(--mantine-color-turquoise-5)'} />
    {label && (
      <Text ml={'xs'} size={'sm'}>
        {label}
      </Text>
    )}
  </Center>
);
